import { createSlice } from "@reduxjs/toolkit";
import { CM0013SliceType } from "../../entity/Entity";

export const initialState: CM0013SliceType = {
  isRefresh: false,
  dataMaterialCost: [],
  checkedCollapse: [],
};

export const CM0013Slice = createSlice({
  name: "cm0013",
  initialState,
  reducers: {
    refreshCM0013: (state) => {
      state.isRefresh = !state.isRefresh;
    },
    setDataMaterialCost: (state, action) => {
      state.dataMaterialCost = action.payload;
    },
    setCheckedCollapseDirect: (state, action) => {
      state.checkedCollapse = action.payload;
    },
    setCheckedCollapse: (state, action) => {
      const data = action.payload;
      const isExisted = state.checkedCollapse.some(
        (element) => element.id === data.id
      );
      if (isExisted) {
        state.checkedCollapse = state.checkedCollapse.map((element) => {
          if (element.id === data.id) return data;
          return element;
        });
      } else state.checkedCollapse = [...state.checkedCollapse, data];
    },
    setCheckedCollapseParent: (state, action) => {
      const id = action.payload.id;
      const isChecked = action.payload.checked;

      if (!isChecked) {
        state.checkedCollapse = state.checkedCollapse.filter(
          (element) => element.id !== id
        );
      } else {
        const isExisted = state.checkedCollapse.some(
          (element) => element.id === id
        );

        if (!isExisted) {
          state.checkedCollapse = [
            ...state.checkedCollapse,
            { id: id, checked: [] },
          ];
        }
      }
    },
    resetCM0013: () => initialState,
  },
});

export const {
  refreshCM0013,
  setDataMaterialCost,
  setCheckedCollapse,
  resetCM0013,
  setCheckedCollapseParent,
  setCheckedCollapseDirect,
} = CM0013Slice.actions;

export default CM0013Slice.reducer;
